export class PollingConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "monitorIntervalSeconds",
            "baseName": "monitorIntervalSeconds",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PollingConfig.attributeTypeMap;
    }
    constructor() {
    }
}
